import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '@/views/HomeView.vue'
import InformeDetail from '@/views/InformeDetail.vue'
import TeleLaudoView from '@/views/TeleLaudoView.vue'
import WorksView from '@/views/WorksView.vue'
import ReportView from '@/views/ReportView.vue'

const routes = [
  {
    path: '/',
    name: 'HomeView',
    component: HomeView,
    meta: { title: 'Portal CCDTI' }
  },
  {
    path: '/informe/:id',
    name: 'InformeDetail',
    component: InformeDetail,
    meta: { title: 'Detalhes do Informe - Portal CCDTI' }
  },
  {
    path: '/telelaudo',
    name: 'TeleLaudoView',
    component: TeleLaudoView,
    meta: { title: 'Telelaudo - Portal CCDTI' }
  },
  {
    path: '/relatorios',
    name: 'ReportView',
    component: ReportView,
    meta: { title: 'Relatórios - Portal CCDTI' }
  },
  {
    path: '/portalweb',
    name: 'WorksView',
    component: WorksView,
    meta: { title: 'Works - Portal CCDTI' }
  },
  {
    path: '/:catchAll(.*)',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// Após cada navegação, atualiza o título da página
router.afterEach((to) => {
  document.title = to.meta.title || 'Portal CCDTI'
})

export default router
